import { render, staticRenderFns } from "./examination-instructions.vue?vue&type=template&id=8be1449c&scoped=true"
import script from "./examination-instructions.vue?vue&type=script&setup=true&lang=ts"
export * from "./examination-instructions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./examination-instructions.vue?vue&type=style&index=0&id=8be1449c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be1449c",
  null
  
)

export default component.exports